import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalBiometryComponent } from 'src/app/main/01-essential/student/modal-biometry/modal-biometry.component';
import { ModalKeyboardComponent } from 'src/app/main/01-essential/student/modal-keyboard/modal-keyboard.component';
import { UnlockAccessComponent } from 'src/app/main/01-essential/student/unlock-access/unlock-access.component';
import { ReleaseEntrance } from '../models/socketMessage';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  constructor(private bsModalService: BsModalService) {}

  showModalUnlockAccess(unitCodeSelected: string, title: string, unlockStudent: boolean = false, dataStudent?: ReleaseEntrance) {
    const bsModalDespesaRef: BsModalRef = this.bsModalService.show(UnlockAccessComponent);
    bsModalDespesaRef.content.title = title;
    bsModalDespesaRef.content.isUnlockStudent = unlockStudent;
    bsModalDespesaRef.content.unitCodeSelected = unitCodeSelected;

    if (dataStudent) {
      bsModalDespesaRef.content.formUnlockAccess.patchValue({
        nationalId: dataStudent.nationalId,
        name: dataStudent.name,
        profile: 0
      });
    }
    return (<UnlockAccessComponent>bsModalDespesaRef.content).confirmResult;
  }

  showModalBiometry(title: string, nationalId: string) {
    let bsModalDespesaRef: BsModalRef = this.bsModalService.show(ModalBiometryComponent);
    bsModalDespesaRef.content.title = title;
    bsModalDespesaRef.content.nationalId = nationalId;

    return (<ModalBiometryComponent>bsModalDespesaRef.content).confirmResult;
  }

  showModalKeyboard(title: string) {
    let bsModalDespesaRef: BsModalRef = this.bsModalService.show(ModalKeyboardComponent);
    bsModalDespesaRef.content.title = title;
    return (<ModalKeyboardComponent>bsModalDespesaRef.content).confirmResult;
  }
}
